import Assert from "tbAssert";

import ngAnimate from "angular-animate";
import ngAria from "angular-aria";
import uiBootstrap from "angular-ui-bootstrap";

import CalendarGlobalViewServiceModule from "tbClient/services/CalendarGlobalViewService";

const GlobalViewChangeDialogOkResult = "GLOBAL_VIEW_CHANGE_OK";
const GlobalViewChangeDialogCancelledResult = "GLOBAL_VIEW_CHANGE_CANCELLED";
const GlobalViewChangeDialogErrorResult = "GLOBAL_VIEW_CHANGE_ERROR";

class GlobalViewChangeDialogController {
    constructor($uibModalInstance, $log, CalendarGlobalViewService) {
        Assert.StrictAssert(
            $uibModalInstance != null,
            "Missing global view change dialog dependency: uib modal instance");
        Assert.StrictAssert(
            $log != null,
            "Missing global view change dialog dependency: log service");
        Assert.StrictAssert(
            CalendarGlobalViewService != null,
            "Missing global view change dialog dependency: global view service");

        this._modalInstance = $uibModalInstance;
        this._logSvc = $log;
        this._globalViewSvc = CalendarGlobalViewService;
        this._availableViews = Array.from(this._globalViewSvc.availableGlobalViews);
        this._logSvc.debug("available global views", this._availableViews);
        this._selectedView = this._globalViewSvc.getCurrentView().name;
    }

    get availableViews() {
        return this._availableViews;
    }

    get selectedViewName() {
        return this._selectedView;
    }

    set selectedViewName(newVal) {
        this._selectedView = newVal;
    }

    cancelGlobalViewChange() {
        this._modalInstance.dismiss(GlobalViewChangeDialogCancelledResult);
    }

    doGlobalViewChange() {
        this._modalInstance.close({
            status: GlobalViewChangeDialogOkResult,
            selectedView: this._selectedView
        });
    }
}

GlobalViewChangeDialogController.$inject = ["$uibModalInstance", "$log", "CalendarGlobalViewService"];
GlobalViewChangeDialogController.dependencies = [
    CalendarGlobalViewServiceModule,
    uiBootstrap,
    ngAnimate,
    ngAria
];
GlobalViewChangeDialogController.controllerAs = "gvChangeDlgCtrl";
GlobalViewChangeDialogController.template = require("./GlobalViewChangeDialog.tpl.html");
GlobalViewChangeDialogController.results = {
    OK: GlobalViewChangeDialogOkResult,
    CANCEL: GlobalViewChangeDialogCancelledResult,
    ERROR: GlobalViewChangeDialogErrorResult
};

export default GlobalViewChangeDialogController;



//////////////////
// WEBPACK FOOTER
// ./src/directives/GlobalViewUi/global-view-change-dialog/GlobalViewChangeDialogController.js
// module id = gUrg
// module chunks = 1